import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { OOOrderType } from "src/app/shared/models/oo-order-type";
import { OrderTypeZonesComponent } from "./order-type-zones/order-type-zones.component";

@Component({
	selector: "app-order-type-record-setup",
	templateUrl: "./order-type-record-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class OrderTypeRecordSetupComponent implements OnInit {
	@ViewChild("orderTypeZones") orderTypeZones: OrderTypeZonesComponent;
	@Input() orderType: OOOrderType;
	@Output() orderTypeChange = new EventEmitter<OOOrderType>();

	clonedOrderType: OOOrderType;

	changesToSave: boolean = false;

	venueLocation: string;
	viewMode: number = 0;

	constructor(public app: AppService, public venueSvc: OOVenueService) {}

	ngOnInit(): void {
		this.clonedOrderType = { ...this.orderType };
	}

	async onSave() {
		await this.venueSvc.ooOrderTypeSave(this.orderType);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Order type saved successfully` });
		if (this.orderTypeZones.changesToSave) {
			this.orderTypeZones.saveZones();
		}

		this.changesToSave = false;
	}

	onDelete() {
		this.venueSvc.ooOrderTypeDelete(this.orderType);
		this.orderTypeChange.emit(undefined);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Order type deleted successfully. 👋` });
	}

	onCancel() {
		if (this.changesToSave) {
			this.app.confirmation.confirm({
				message: `Close with unsaved changes?`,
				accept: async () => {
					const idx = this.venueSvc.ooOrderTypes.findIndex((i) => i.key === this.clonedOrderType.key);
					this.venueSvc.ooOrderTypes[idx] = this.clonedOrderType;
					this.orderTypeChange.emit(undefined);
				},
				reject: async () => {
					this.app.confirmation.close();
				},
			});
		} else {
			this.orderTypeChange.emit(undefined);
		}
	}
}
